
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import oo from "../../../images/img/oo.png"
import InputText from "../../shared/input/new/InputText"
import Button from "../../shared/button/Button"
import { addKayitliLoad } from "../../../features/kayit/kayitSlice"
import moment from "moment"
import { resetAddLoadState } from "../../../features/addLoad/addLoadSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 800px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .img-kamyonoo{
            width: 80px;
            height: 40px;
            margin-bottom: 20px;
        }

        h2{
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-lg);
            margin-bottom: 30px;
        }

        p{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            margin-bottom: 30px;

        }

        .btn-grp{
            margin-top: 30px;
            width: 80%;
            display: flex;
            justify-content: center;
        }           
    }
`

const AddLoadYukKaydiModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [text, setText ] = useState("")
    const [activeItem, setActiveItem] = useState({
        id:1,
        text: "Herkese Yayınla",
    })

    const {route, aracData, paymentData, yukData, paketlemeData, routeDistance, selectedProjectAddLoad} = useSelector(state => state.addLoad)

    
    const handleAddKayit = () => {

        const data = {
            //! load
                isParsiyel: yukData?.yuklemeTuru.value,
                loadtype: yukData?.yukTuru,
                isDangerous: yukData?.yukADR,
                dangerousDescription: yukData?.yukAdrDescription,
                loadQuantity: yukData?.agirlikBirim.value === 3 ? 1 : parseInt(yukData?.toplamAgirlik),
                loadUnit: yukData?.agirlikBirim.text,
                loadUnitId: yukData?.agirlikBirim.value,
                loadBulk: parseInt(yukData?.toplamHacim)  || 0,
                loadDescription: yukData?.yukDesc,
                loadValue: parseInt(yukData?.yukunDegeri) || 0,
                isInsuranceRequested: false, 
                yakıtVar: false,

                truckQuantity: parseInt(aracData.aracSayisi),
                usedTruckQuantity: 0,
                truckType: aracData.aracTypeName,
                truckTypeId: aracData.aracTypeId,
                trailerType: aracData.kasaTypeName,
                trailerTypeId: aracData.kasaTypeId,
                groundType: aracData.zeminType.text ? aracData.zeminType.text : "Farketmez",
                groundTypeId: aracData.zeminType.value || 0,
                truckDescription: aracData.digerOzellikler,

                loadOwnerFreight: 0,
                freightVisibility: false,
                freight: 0,
                distance: parseInt(routeDistance)  || 0,
                publishingTypeId: activeItem.id,
                isActive: false,
                isFavorite: false,
                commissionPaymentId: paymentData.komisyonDurumu.value || 0, 
                commissionPayment: paymentData.komisyonMiktari.value === 0 ? 0 : parseInt(paymentData.komisyonMiktari),
                fuelPaymentId: paymentData.yakitDurumu.value || 0,
                fuelPayment:  paymentData.yakitDurumu.value === 0 ? 0 : parseInt(paymentData.yakitOrani),
                paymentType: paymentData.odemeSekli.text,
                paymentTypeId: paymentData.odemeSekli.value,
                paymentUnit: paymentData.fiyatlandirmaType.value,
                otherPaymentDescription: paymentData.odemeSekliDigerAciklama,
                companyProjectId: selectedProjectAddLoad?.id || "",

            //! route
            routePoints: route.map((item, i) => {
                return {
                    city: item.locationData.il,
                    town: item.locationData.ilce,
                    regionId: item.locationData.bolgeId,
                    address: item.adres,
                    forDirections: item.adresTarif,
                    location: item.locationData.location,

                    //! yetkili bilgileri
                    companyName: item?.companyName || "",
                    routePointPersonPhoneNumber: (item.routePointPersonPhoneNumber?.startsWith("+90") || item.routePointPersonPhoneNumber?.startsWith("90")) ? item.routePointPersonPhoneNumber?.slice(2) : item.routePointPersonPhoneNumber || "",
                    mailAddress: item.mailAddress || "",
                    routePointPersonName: item.routePointPersonName || "",
                    smsVerification: item.smsVerification || false,
                    smsVerificationPhoneNumber: (item.smsVerificationPhoneNumber?.startsWith("+90") || item.smsVerificationPhoneNumber?.startsWith("90")) ? item.smsVerificationPhoneNumber?.slice(2) : item.smsVerificationPhoneNumber || "",

                    googleLat: item?.locationData?.isGoogleAddressSelected ? item?.locationData?.googleLat : null,
                    googleLng: item?.locationData?.isGoogleAddressSelected ? item?.locationData?.googleLng : null,
                    isGoogleAddressSelected: item?.locationData?.isGoogleAddressSelected,
                    googleAddress: item?.locationData?.googleLocation ? item?.locationData?.googleLocation : null,

                    //! burada order gelecek, addLoad slice a da eklenmeli
                    order: i+1,
                    loadOrUnload: item.locationType === "yukleme" ? 0 : 1, 
                    lat: item.locationData.lat.toString(),
                    lng: item.locationData.lng.toString(),
                    //! bu tarihleri date tipinde yapılacak
                    loadDate: moment().format(item.date),
                    lateLoadDate: moment().format(item.dateEngec),
                    loadTime: item.saatBaslangic,
                    lateLoadTime: item.saatBitis,
                    loadAllTime: item.saatAllTime,
                    isAddressSaved: item.adresKaydedilsinMi,
                    savedAddressName: item.adresBaslik,
                    loadMethods: item.sevkBicimleri.filter((item) => {
                        return item.status
                    }).map(item => {
                        return {name: item.name, methodId: item.id}
                    })
                }
            }),

            packingingTypes: paketlemeData.map(item => {
                return {
                    packagingUnitId: item.activePaketlemeTypeId,
                    olculers: item.list.map(item => {
                        return {
                            en: parseInt(item?.en || 0),
                            boy: parseInt(item?.boy || 0),
                            yukseklik: parseInt(item?.yukseklik || 0),
                            agirlik: parseInt(item?.agirlik || 0),
                            sayisi: parseInt(item?.sayisi || 0),
                            cap: parseInt(item?.cap || 0),
                        }
                    })
                }
            })
        }
        if(text?.length > 0){
            
            dispatch(addKayitliLoad({...data, saveLoadName: text, isLoadSaved:true}))
            
        }else{
            dispatch(showModal(null))
            navigate("/yukler-listesi")
            localStorage.removeItem("routeData");
            dispatch(resetAddLoadState())
        }
    }
    
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = ()=> {

        if(text){
            handleAddKayit()
        }

        else{
            dispatch(showModal(null)); navigate("/yukler-listesi")
            dispatch(resetAddLoadState())

        }
    }

 
  return (
    <Container onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <img src={oo} alt="kamyoon" className="img-kamyonoo" />
            <h2>Tebrikler... Yük Kaydınız Başarıyla Tamamlanmıştır</h2>
            <p>Bu yük kaydını ileride tekrar kullanmak istersen kayıt adı vererek kaydedebilirsin.</p>
            <InputText data={text} setData={(e) => setText(e.target.value)} labelText="Yük Kaydı Adı Giriniz" inputWidth={"80%"} isRequired={true} name={"yukKaydiIsmi"}/>
            <div className="btn-grp">
                <Button handleClick={handleSubmit} text={text ? "Kaydet" : "Çıkış"} width="45%" background={"#E85446"} />
            </div>
        </div>
    </Container>
  )
}

export default AddLoadYukKaydiModal